<script>
import baseConfig from '../../../config'

import helpers from '@mixins/helper'

export default {
  mixins: [helpers],
  name: 'update-manager-popup',
  data () {
    return {
      mostrarModal: false,
      versaoAtual: null
    }
  },
  mounted () {
    this.versaoAtual = baseConfig.appVersion
    this.checkBuildVersion()
  },
  computed: {
    isMobileSize: function () {
      return this.isMobile().any()
    }
  },
  watch: {
    $route (to, from) {
      this.checkBuildVersion()
    }
  },
  methods: {
    checkBuildVersion () {
      if (this.versaoAtual) {
        window.fetch('/static/build.txt?t=' + Date.now(), {
          headers: {'Cache-Control': 'no-cache'}
        }).then((response) => {
          response.text().then((build) => {
            build = build.trim()

            if (build !== this.versaoAtual) {
              this.mostrarModal = true
            }
          })
        })
      }
    },
    clearBrowserCacheAndReload () {
      if ('caches' in window) {
        window.caches.keys().then((names) => {
          names.forEach(async (name) => {
            await window.caches.delete(name)
          })
        })
      }

      window.location.reload(true)
    },
    fecharModal () {
      this.mostrarModal = false
      this.clearBrowserCacheAndReload()
    }
  }
}
</script>

<template>
  <div>
    <v-dialog v-model="mostrarModal"
              :width="isMobileSize ? '90%' : '40%'"
              persistent>
      <v-card class="popup-modal">
        <v-container>
          <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">
            Atualização
          </h3>
          <div class="text">
            <p :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
              Olá, você está com uma versão antiga desta aplicação no seu navegador. Clique em fechar
              para atualizar. Se essa mensagem persistir, por favor, force a atualização diretamente pelo seu navegador.
            </p>
          </div>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="fecharModal">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// UpdateManager.vue?172c26ee